// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import OlMap from 'ol/map';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import ArrowIcon from './../../../../icons/arrow.svg';

const StyledRotationSlider = styled.div`
  position: absolute;
  left: 42px;
  top: 11px;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  input[type=range] {
    -webkit-appearance: none;
    : 15px 0;
    width: calc(100% - 35px);
  }

  input[type=range]:focus {
    outline: none;
  }

  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    background-color: #a7a7a7;
  }

  input[type=range]::-webkit-slider-thumb {
    border: 1px solid #ffffff;
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background-color: #f8f8f8;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -5px;
  }

  input[type=range]:focus::-webkit-slider-runnable-track {
    background-color: #a7a7a7;
  }

  input[type=range]::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    background-color: #a7a7a7;
  }

  input[type=range]::-moz-range-thumb {
    height: 16px;
    width: 16px;
    border-radius: 8px;
    background-color: #f8f8f8;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -5px;
  }

  input[type=range]::-ms-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    border-width: 16px 0;
    color: transparent;
  }

  input[type=range]::-ms-fill-lower {
    border-radius: 2.6px;
  }

  input[type=range]::-ms-fill-upper {
    background-color: #a7a7a7;
    border-radius: 2.6px;
  }

  input[type=range]::-ms-thumb {
    height: 20px;
    width: 16px;
    border-radius: 3px;
    cursor: pointer;
  }

  input[type=range]:focus::-ms-fill-lower {
    background-color: #a7a7a7;
  }

  input[type=range]:focus::-ms-fill-upper {
    background-color: #a7a7a7;
  }
`;

const Outline = styled.div`
  height: 25px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  background-color: #464646;
`

const NorthArrowWrapper = styled.div`
  :hover{
    svg{
      polygon{
        fill: #a7a7a7;
      }
    }
  }
`;

type RotationSliderState = {
  rotation: number;
}

type RotationSliderProps = {
  olMap: OlMap,
  rotation: number
};

export class RotationSlider extends React.Component<RotationSliderProps, RotationSliderState> {
  constructor(props) {
    super(props);
    this.state = {
      rotation: props.rotation
    }
  }

  componentDidUpdate(prevProps): void {
    const { rotation } = this.props;
    if (rotation !== prevProps.rotation) {
      this.setRotation(rotation);
    }
  }

  setRotation(rotation: number): void {
    const { olMap }: MapProps = this.props;
    const rotationInRadians: number = rotation === 0 ? 0 : Math.PI * rotation / 180;
    this.setState({
      rotation: rotation
    });
    olMap.getView().setRotation(rotationInRadians);
  }

  render(): React.Node {
    const rot: string = this.state.rotation.toString();

    return (
      //TODO: przemyśleć przerobienie na obracaną strzałkę https://github.com/denilsonsa/html5-knob
      <StyledRotationSlider>
        <Outline>
          <NorthArrowWrapper
            onClick={() => {
              this.setRotation(0);
            }}>
            <ReactSVG
              path={ArrowIcon}
              style={{
                fill: '#ffffff',
                width: '25px',
                height: '20px',
                transform: `rotate(${rot}deg)`,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            />
          </NorthArrowWrapper>
          <input
            type="range"
            value={rot}
            min="0" max="360"
            onChange={event => {
              this.setRotation(parseInt(event.target.value, 10));
            }} />
        </Outline>
      </StyledRotationSlider>
    );
  }
};

const mapStateToProps = state => ({
  rotation: state.mapData.get('rotation')
});

export default connect(mapStateToProps)(RotationSlider);


// WEBPACK FOOTER //
// ./src/containers/content/map/rotationSlider/RotationSlider.jsx